<template>
  <div id="businessList" class="app-inner">
    <div class="public-btn-div flex align-cen" v-if="!authType">
      <div class="public-add"  @click="addBusiness">
        新增企业
      </div>
    </div>
    <div class="p-tit-c">
    <!-- <div class="businessList_header flex align-cen">
      <el-input placeholder="企业名称" v-model="search" clearable> </el-input>
      <el-input placeholder="企业ID" v-model="search1" clearable > </el-input>
      <el-input placeholder="企业电话" v-model="search2" clearable > </el-input>
    </div> -->

    <div class="businessList-filter">
      <div class="businessList-filter-list flex align-cen">
            <div class="fl-le flex align-cen">
          <div class="label">企业名称：</div>
          <div class="el-select1">
            <el-input placeholder="请输入企业名称" v-model="search" clearable> </el-input>
          </div>
         </div>
             <div class="fl-rt flex align-cen">
          <div class="label">企业标识：</div>
          <div class="el-select1">
          <el-input placeholder="请输入企业ID" v-model="search1" clearable> </el-input>
          </div>
         </div>
           <div class="fl-rt flex align-cen">
          <div class="label">企业电话：</div>
          <div class="el-select1">
          <el-input placeholder="请输入企业电话" v-model="search2" clearable> </el-input>
          </div>
         </div>
      </div>
      <div class="businessList-filter-list flex align-cen">
        <div class="fl-le flex align-cen">
          <div class="label">企业分类：</div>
          <el-select
            v-model="value"
            clearable
            placeholder="请选择"
            @change="classSelect"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="fl-rt flex align-cen">
          <div class="label">企业状态：</div>
          <el-select
            v-model="value1"
            clearable
            placeholder="请选择"
            @change="classSelect"
          >
            <el-option
              v-for="item in options1"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="businessList-filter-list flex align-cen" v-if="!authType">
        <div class="label">账号状态：</div>
        <div
          style="color: red; padding-right: 20px; cursor: pointer"
          @click="allradio"
        >
          不限
        </div>
        <el-radio v-model="radio" label="1" @change="gethisInfo">启用中</el-radio>
        <el-radio v-model="radio" label="0" @change="gethisInfo">禁用</el-radio>
      </div>
      <div class="businessList-filter-list flex align-cen">
        <div class="label">创建时间：</div>
        <el-date-picker
          v-model="value2"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions2"
          @change="dataSuccess"
        >
        </el-date-picker>
      </div>
      <div class="businessList-filter-list flex align-cen public-btn-small">
        <div class="public-btn-small-primary" @click="searchList">
          搜索
        </div>
        <div class="public-btn-small-plan" @click="exportExcel(multipleSelection)" v-if="!authType">
          导出
        </div>
        <div class="public-btn-small-text" @click="reset">
          重置筛选条件
        </div>
      </div>
    </div>
    </div>
    <div class="businessList-container">
      <!-- <div class="businessList-container-title flex align-cen">
        <div class="export" @click="exportExcel(multipleSelection)">
          <el-button type="plain" icon="icon-al-cloudupload-fill">
            导出数据</el-button
          >
        </div>
        <div class="mft">
          <i class="el-icon-circle-plus"></i> 新增企业
        </div>
      </div> -->
      <!-- 表格 -->
      <div class="businessList-container-table">
        <el-table
          ref="multipleTable"
          :data="itemList"
          tooltip-effect="dark"
          style="width: 100%"
          border
          :row-key="getRowKeyOfTarget"
          @selection-change="handleSelectionChange"
          id='mytable'
          :header-cell-style="{background:'#f7f8fa',color:'#333'}"
           v-loading="loading"
          element-loading-text="数据拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.6)"
        >
          <el-table-column type="selection" width="55" align="center" reserve-selection v-if="!authType" fixed="left" > </el-table-column>
          <el-table-column prop="id" label="企业id" align="center" width="150">
          </el-table-column>
          <el-table-column prop="name" label="企业名称" align="center" width="220">
          </el-table-column>
          <el-table-column prop="classifyName" label="企业类型" align="center" width="150">
          </el-table-column>
          <el-table-column label="企业电话" align="center" width="200">
            <template slot-scope="scope">
              <div
                class="flex align-cen justify-content-cen"
                style="width: 100%"
              >
                <div v-if="scope.row.showPhone">
                  {{ $util.getRegular(scope.row.phone) }}
                </div>
                <div v-else>{{ scope.row.phone }}</div>
                <el-button
                  type="text"
                  @click="see(scope)"
                  style="padding-left: 10px"
                  >查看</el-button
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column label="账号状态" align="center" v-if="!authType">
            <template slot-scope="scope">
              <div class="buStatus" @click.stop="changeStatus(scope)">
                <el-switch
                  v-model="scope.row.accountState == 0 ? false : true"
                  disabled
                >
                </el-switch>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center" width="200">
          </el-table-column>
          <el-table-column label="企业状态" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.state == 0
                  ? "试用"
                  : scope.row.state == 1
                  ? "有意向"
                  : scope.row.state == 2
                  ? "谈判"
                  : scope.row.state == 3
                  ? "合作中"
                  : "停止合作"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center"
           fixed="right" 
           width="150"
          v-if="!authType">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click.stop="editPro(scope.row)"
                >编辑</el-button
              >
               <el-button
                type="text"
                size="small"
                @click.stop="detail(scope.row)"
                >查看详情</el-button >
              <!-- <el-button
                type="text"
                size="small"
                @click.stop="deletPro(scope.row)"
                style="color:red"
                >删除</el-button
              > -->
            </template>
          </el-table-column>
           <el-table-column label="操作" align="center" v-if="authType">
            <template slot-scope="scope">
          <el-button
                type="text"
                size="small"
                style="color:red"
                @click="emitchose(scope.row)"
                >选择</el-button >
            </template>
           </el-table-column>
        </el-table>
        <el-pagination
          class="jiange"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="pageSizes"
          :page-size="PageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import {getbusinessList,editbusinessStatus,deletList,getbusinesstypelist} from "@/api/index/index"  //企业列表、企业分类新增修改接口、删除项目、企业分类
import exportExcel from '../../utils/exportExcel.js' //导出数据公共方法
export default {
	name: "businessList",
   props: {
    authType:[String, Number]//是否为组件调用
    },
	 data: () => {
    return {
      loading:false,
        radio:'',
        seetext:'查看',
             pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
          tableData: [],
        multipleSelection: [],
        edittype:0,
        tit:'',
        centerDialogVisible:false,
        totalNum:0,
        currentPage: 1, //初始页
        PageSize: 10, //每页的数据
        totalCount: 0,
        pageSizes:[10,20,30,40,50,100],
        newArry:[],
        search:'',
        search1:'',
        search2:'',
        itemList:[],
        data1: '',
        date2: '',
        checkList:[],
         options: [],
         options1: [{
          value: '0',
          label: '试用'
        }, {
          value: '1',
          label: '有意向'
        },{
          value: '2',
          label: '谈判'
        },
        {
          value: '3',
          label: '合作中'
        },
        {
          value: '4',
          label: '停止合作'
        }
        ],
        value:'',
        value1:'',
        value2:'',
        start_time:'',
        end_time:'',
        keepAlive:''
	}
	},
	mounted(){
     
	},
activated(){
  this.gethisInfo()
},
    created(){
        if(this.authType) this.gethisInfo()
        this.loading = true
        this.getbusClass()
       
    },
	methods: {
      //  父组件选择事件
            emitchose(data){
              this.$emit('sendStatus1', data)
            },
        inputchange(e){
          this.$forceUpdate()
        },
         getRowKeyOfTarget(row) {
            return row.id
            },
        // 筛选
        // 不限
        allradio(){
            // this.search = ""
            // this.search1 = ""
            // this.search2 = ""
            this.radio = ""
            this.currentPage = 1
            this.gethisInfo()
        },
        classSelect(){
            // this.search = ""
            // this.search1 = ""
            // this.search2 = ""
            this.currentPage = 1
            this.gethisInfo()
        },
        dataSuccess(){
            // this.search = ""
            // this.search1 = ""
            // this.search2 = ""
            if(this.value2){
             this.start_time = this.value2[0]
            this.end_time = this.value2[1]
            }else{
              this.start_time = ""
              this.end_time = ""
            }
            this.currentPage = 1
            this.gethisInfo()
        },
        // 搜索
        searchList(){
               this.currentPage = 1
           this.gethisInfo()
        },
        // 重置
        reset(){
            this.search = ""
            this.search1 = ""
            this.search2 = ""
            this.value = "",
            this.value1 = "",
            this.radio = "",
            this.value2 = "",
            this.start_time = ""
            this.end_time = ""
            this.currentPage = 1
            this.gethisInfo()
        },
        // 获取企业分类
        getbusClass(){
            getbusinesstypelist({})
            .then(res => {
              this.options = res.data
            })
            .catch(err => {
            })
        },
        // 查看手机号
        see(data){
          data.row.showPhone = false
        },
        // 表格选择
         handleSelectionChange(val) {
        this.multipleSelection = val;
      },
        // 导出
          exportExcel(val){ 
            if(val.length !=0){
            let keyLisst = [] 
            for(let item in val){
             keyLisst.push( {
              '企业ID':val[item].id, 
              '企业名称':val[item].name, 
              '企业类型':val[item].classifyName,
              '企业电话':val[item].phone,
              '创建时间':val[item].createTime, 
              '账号状态':val[item].accountState == 1 ? '开启' : '禁用',
              '企业状态': val[item].state == 0 ? '试用' : val[item].state == 1 ? '有意向' : val[item].state == 2 ? '谈判' : val[item].state == 3 ? '合作中' : '停止合作',
              '企业地址': val[item].province + val[item].city + val[item].district + val[item].address
              } ) 
             }
         exportExcel.exportExcel(keyLisst,this.$route.meta.title)
            }else{
               this.$message.error('未选择导出数据'); 
            }
          },
      changeStatus(e){
       if(e.row.accountState == 1){
          this.$prompt('确认后将导致该用户无法系统，仍要进行吗？', '企业账号禁用', {
          inputPlaceholder:'处理备注【必填】',
          inputType:'textarea',
          inputPattern:/^[0-9a-zA-Z\u4E00-\u9FA5\uf900-\ufa2d·s]{1,50}$/,
          inputErrorMessage: '请输入1-50字符',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
            this.editbusiness(e,value)
        }).catch(() => {     
        });
       }else{
        this.editbusiness(e,'')
       }
      },
        editbusiness(e,value){
             editbusinessStatus({
                id:e.row.id,
                accountState:e.row.accountState == 1 ? '0' : '1',
                remark:value
                    },'put')
                .then(res => {
                  if(res.code ==1){
                     this.$message.error(res.msg); 
                  }else{

                      this.$message.success('企业状态修改成功'); 
                    this.gethisInfo()
                  }
                })
                .catch(err => {
                })
        },
        // 删除项目
         deletPro(data){
          this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            deletList({
              id:data.id,
              },'delete')
                .then(res => {
                  this.$message.success('已删除');
                   this.gethisInfo()
              })
              .catch(err => {
              })
        })
      },
        // 确定
        onsubmit(formName){
            this.$refs[formName].validate((valid) => {
                if(valid){
                    if(this.edittype == 0){
                        editbusinessStatus(
                            {
                                name:this.formLabelAlign.name,
                                sort:this.formLabelAlign.sort
                            },
                            'post')
                        .then(res => {
                           this.$message.success('添加成功'); 
                           this.gethisInfo()
                           setTimeout(() => {
                      this.centerDialogVisible = false
                    }, 100);
                        })
                        .catch(err => {

                        })
                    }else{
                            getbusinessedit(
                            {
                                name:this.formLabelAlign.name,
                                sort:this.formLabelAlign.sort,
                                id:this.formLabelAlign.id
                            },
                            'put')
                        .then(res => {
                           this.$message.success('修改成功'); 
                           this.gethisInfo()
                           setTimeout(() => {
                      this.centerDialogVisible = false
                    }, 100);
                        })
                        .catch(err => {

                        })
                    }
                }
            })
        },
        // 打开新增企业
        addBusiness(){
            this.$router.push("/editBusiness")
        },
        // 修改企业
        editPro(data){
           this.$router.push({
            name: "editBusiness",
            query:{
                id:data.id
            }
           })
        },
        // 打开企业详情
        detail(data){
            this.$router.push({
            name: "businessDetail",
            query:{
                id:data.id,
                type:1
            }
           })
        },
        // 获取列表
        gethisInfo(){
          if(this.authType) this.radio = this.authType
            let params = {
                name:this.search,
                id:this.search1,
                phone:this.search2,
                classifyIds:this.value,
                state:this.value1,
                accountState:this.radio,
                startTime:this.start_time,
                endTime:this.end_time,
                current: this.currentPage,
                size:this.PageSize,
            }
            getbusinessList(params)
            .then(res => {
              this.itemList = res.data.records
              for (const i in  this.itemList) {
                this.$set(this.itemList[i], 'showPhone', true)
              }
             this.totalCount = res.data.total;
             this.loading = false
            })
            .catch(err => {
              this.loading = false
            })
        },
     handleSizeChange(val) {
       this.PageSize = val
       this.gethisInfo()
    },
    handleCurrentChange(val) {
      this.currentPage = val
       this.gethisInfo()
    },
	}
}
</script>
<style lang="scss" scoped>
#businessList {
  padding: 0 20px;
  .businessList_header {
    padding-bottom: 20px;
    border-bottom: 1px solid #ccc;
    .el-input {
      width: 250px;
      margin-right: 20px;
    }
  }
  .businessList-filter {
    padding-top: 10px;
    .businessList-filter-list {
      margin-top: 20px;
      .fl-rt {
        padding-left: 30px;
      }
    }
    .businessList-filter-list:first-child {
      margin-top: 0;
    }
  }
  .businessList-container {
    .businessList-container-title {
      font-size: 18px;
      color: #409eff;
      background-color: rgba(242, 242, 242, 1);
      padding: 10px 20px;
      .mft {
        cursor: pointer;
      }
    }
    .businessList-container-table {
      margin-top: 20px;
      .el-table{
        min-height: 300px;
      }
      .el-switch {
        position: relative;
        z-index: 1 !important;
      }
      .el-switch.is-disabled {
        opacity: 1 !important;
      }
      .buStatus{
        width: 50px;
        margin: 0 auto;
      }
    }
    .jiange {
      margin-top: 20px;
    }
  }
}
.forminfo {
  .btn {
    width: 80%;
    height: 50px;
    background-color: #409eff;
    border-radius: 0.1vh;
    border: none;
    color: #fff;
    margin: 20px auto;
    margin-bottom: 0;
    text-align: center;
    line-height: 50px;
    cursor: pointer;
  }
}
::v-deep {
  .el-switch.is-disabled .el-switch__core {
    cursor: pointer !important;
    width: 50px !important;
  }

}
</style>